// <s-age-gate> shows the 21+ dialog until the visitor confirms, then remembers it.
const STORAGE_KEY = 'tb-age-verified';

class SAgeGate extends HTMLElement {
  #ac;

  connectedCallback() {
    const dialog = this.querySelector('dialog');
    if (!dialog) return;
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };

    // Visitors must answer; Escape does not dismiss the gate.
    dialog.addEventListener('cancel', (e) => e.preventDefault(), opts);

    this.addEventListener('command', (e) => {
      if (e.command !== '--confirm') return;
      try { localStorage.setItem(STORAGE_KEY, '1'); } catch (_) { /* storage unavailable */ }
      dialog.close();
    }, opts);

    if (this.hasAttribute('data-design-mode')) {
      // In the editor, open only while the block is selected so the page stays editable.
      document.addEventListener('shopify:block:select', (e) => {
        if (this.contains(e.target)) dialog.show();
      }, opts);
      document.addEventListener('shopify:block:deselect', (e) => {
        if (this.contains(e.target)) dialog.close();
      }, opts);
      return;
    }

    let verified = false;
    try { verified = localStorage.getItem(STORAGE_KEY) === '1'; } catch (_) { verified = false; }
    if (!verified && !dialog.open) dialog.showModal();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-age-gate')) customElements.define('s-age-gate', SAgeGate);
